angular.module('app.filters').filter('boxcasterKey', () =>
    function(k) {
        if (k == null) { return ''; }
        if (k.set && (k.value != null)) {
            return k.value;
        } else {
            return '(not set)';
        }
    }
);


// WEBPACK FOOTER //
// ./filters/boxcaster_key.js